import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'
import { ProcessingCost } from '../types'

export type RemoveProcessingCostAction = FSA<undefined, number, string>
type RemoveProcessingCost = (processingCost: ProcessingCost) => MrxThunk<RemoveProcessingCostAction, Promise<boolean>>
type QueryResponse = GraphQLResponse<'removeProcessingCost', boolean>

const REMOVE_PROCESSING_COST = `
mutation RemoveProcessingCost($workspaceId: Int!, $date: DateTime!) {
  removeProcessingCost(workspaceId: $workspaceId, date: $date)
}
`

export const removeProcessingCost: RemoveProcessingCost = (processingCost) => async (dispatch, getState) => {
  let isSaved = false

  dispatch({
    type: t.REMOVE_PROCESSING_COST,
    meta: { done: false }
  })

  try {
    const workspaceId = getState()?.workspaces?.activeWorkspace?.id

    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: REMOVE_PROCESSING_COST,
      variables: { workspaceId, date: new Date(processingCost.date) }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { removeProcessingCost } = data
    if (!removeProcessingCost) {
      throw new Error("Can't remove processing cost!")
    }

    dispatch({
      type: t.REMOVE_PROCESSING_COST,
      payload: processingCost.id,
      meta: { done: true }
    })
    isSaved = true
  } catch (err) {
    dispatch({
      type: t.REMOVE_PROCESSING_COST,
      payload: extractErrorInfo(err),
      error: true
    })
  }

  return isSaved
}
